module.exports = __webpack_public_path__ + "static/media/home-kogi-cosby.13d4f5c2.jpg";